import { combineReducers } from '@reduxjs/toolkit'
import {
  abortActionReducer,
  notificationsReducers,
  otpValidationReducer,
  requestReferencesReducers,
} from '@repo/core'
import {
  appearanceReducer,
  filterAndVisualizationReducer,
  languageReducer,
  stepperReducer,
} from '../slices'

// Exposed as a map (not pre-combined) so consumers can extend the `app` slice with extra reducers.
export const appSliceReducers = {
  appearance: appearanceReducer,
  filterAndVisualization: filterAndVisualizationReducer,
  language: languageReducer,
  notifications: notificationsReducers,
  requestReferences: requestReferencesReducers,
  otpValidation: otpValidationReducer,
  stepper: stepperReducer,
  abortAction: abortActionReducer,
}

export const appRootReducers = {
  app: combineReducers(appSliceReducers),
}
